import { Widget } from "@foretagsplatsen/widgetjs";
import FormulaWidget from "../../../core/widgets/keyFigures/FormulaWidget.js";

/**
 * Renders a panel with a typeset key figure's formula.
 *
 * @param {dimension} [spec.dimensionTree] - Root dimension from which
 * dimension ids are resolved.
 */
export default class KeyFigureDefinitionWidget extends Widget {
	constructor({ dimensionTree }) {
		super(...arguments);

		this._formulaWidget = new FormulaWidget({ dimensionTree });
	}

	setFormula(formula) {
		this._formula = formula;
		this._formulaWidget.setFormula(formula);
		this.update();
	}

	renderContentOn(html) {
		html.div(
			{
				klass: "panel single-kpi-formula",
				"data-test": "single-kpi-formula",
			},
			html.div({ klass: "panel-body" }, this._formulaWidget),
		);
	}
}
